import { Map, Record } from 'immutable';

export default Record({
    campaignId: null,
    headline: '',
    hex: '',
    id: null,
    impressionSum: null,
    markdown: '',
    medium: [],
    mediumId: null,
    properties: Map({
        links: Map({
            facebook: '',
            pinterest: '',
            twitter: '',
            youtube: '',
        }),
        showClock: true,
        showContact: null,
    }),
    slug: '',
    url: '',
});
